"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginFsp = void 0;
var tslib_1 = require("tslib");
var basePlugin_1 = tslib_1.__importDefault(require("../base/basePlugin"));
var typings_1 = require("../typings");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var img_1 = require("../utils/img");
var const_1 = require("../utils/const");
var imgPattern = /\.(png|jpg|jpeg|gif|webp|ico|bmp|tiff|svg)/i;
var TRIGGER_TIMEOUT = 0;
var TRIGGER_INTERACT = 1;
var mutaRecords = []; // 记录 mutation 新增节点及其对应时间
var domTimer = 0; // DOM 变化监听计时器
var perfTimer = 0; // 资源请求监听计时器
var domDone = false; // DOM 变化监听结束标记
var perfDone = false; // 资源请求监听结束标记
/**触发 fsp 计算的类型 eg: click | touchmove | wheel | timeout  timeout为3s没有监听到 dom 变更 或 资源加载时进行计算 */
var triggerType = TRIGGER_TIMEOUT;
// 首屏dom 监听结束时 采集到的首屏内dom 变更次数
var mutationCount = 0;
// fsp统计时间起点 在容器内由 titans-timestamp 事件获取 在容器外由 performance api 获取
var fspStartTime = performance.timeOrigin || performance.timing.navigationStart;
// 是否为容器初次加载 容器外始终为 true
var hasContainerLoad = true;
// 最终计算为 FSP 的计算方式 dom | img
var collectOrigin = 'dom';
var scrollDom = null;
var STOPTIME = 3000; // 默认的停止监听超时阈值
var NodesFilter = ['HTML', 'HEAD', 'META', 'LINK', 'SCRIPT', 'STYLE', 'NOSCRIPT']; // 非视觉元素
var windowSize = getViewportSize();
var windowHeight = windowSize.height;
var windowWidth = windowSize.width;
var MinArea = windowHeight * windowWidth * 0.05;
/** 自定义维度值最大长度 */
var MAX_TAG_VALUE_LENGTH = 128;
var defaultOption = {
    disable: false,
    includeImage: true,
    mutaStopTime: 3000,
    sampleRate: 10,
    minAreaPercent: 0.05,
    customTags: {},
};
var parseInt = Number.parseInt || window.parseInt;
var PluginFsp = /** @class */ (function (_super) {
    tslib_1.__extends(PluginFsp, _super);
    function PluginFsp(queue, config) {
        if (config === void 0) { config = defaultOption; }
        var _this = _super.call(this, queue, config) || this;
        _this.name = PluginFsp.id;
        _this.observer = null;
        _this.mutaStopTime = STOPTIME;
        _this.perfObserver = null;
        _this.ignoreArr = 'perf_ignore';
        _this.ignoreIframe = true;
        _this.domFsp = 0;
        _this.config = util_1.extend(defaultOption, _this.config);
        _this._editableOption = ['customTags'];
        var mutaStopTime = parseInt(_this.config.mutaStopTime) || 0;
        _this.mutaStopTime = Math.max(mutaStopTime, STOPTIME);
        MinArea = Number(_this.config.minAreaPercent) * windowWidth * windowHeight || MinArea;
        return _this;
    }
    PluginFsp.prototype.init = function () {
        var _this = this;
        var _a;
        if (!window.MutationObserver ||
            !util_1.isFunction(window.MutationObserver) ||
            !((_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.now) ||
            !util_1.isFunction(window.performance.now))
            return false;
        // 初始上报 fsp start 埋点
        this.addData({
            type: 'FSP_Start',
            value: 1,
            ts: Date.now(),
        });
        // web 容器中监听 titans-timestamp 事件
        window.addEventListener('titans-timestamp', function (e) {
            try {
                var detail = util_1.isIOS() ? e.detail : JSON.parse(e.detail);
                var webviewCreate = detail.webviewCreate, loadUrl = detail.loadUrl;
                if (!webviewCreate) {
                    hasContainerLoad = false;
                }
                fspStartTime = webviewCreate || loadUrl;
                // 如果为 ios 默认给出的时间为s 需要对时间戳乘1000 调整到ms https://km.sankuai.com/page/1013521419
                if (util_1.isIOS()) {
                    fspStartTime = Math.floor(fspStartTime * 1000);
                }
            }
            catch (error) { }
        });
        // 初始化时可能 body 仍未存在 加一个定时器
        setTimeout(function () {
            try {
                _this.observer = new window.MutationObserver(function (mutations) {
                    var time = Date.now();
                    _this.mutaCallback(mutations, time, true);
                });
                // 如果 body 存在 则用 body 作为监听对象 减小监听范围
                var container = document.body || document;
                _this.observer.observe(container, {
                    childList: true,
                    subtree: true,
                });
                _this.resetTimer(true);
                if (window.addEventListener) {
                    if (document.readyState === 'complete') {
                        _this.interactToStopObserver();
                    }
                    else {
                        window.addEventListener('load', function () {
                            _this.interactToStopObserver();
                        });
                    }
                }
                if (_this.config.includeImage) {
                    _this.startPerfObserver();
                }
                else {
                    perfDone = true;
                    _this.handleFspReport();
                }
            }
            catch (error) {
                logger_1.default.log('mutation observer observe err', error);
            }
        }, 0);
    };
    PluginFsp.prototype.startPerfObserver = function () {
        var _this = this;
        if (window.PerformanceObserver && util_1.isFunction(window.PerformanceObserver)) {
            this.perfObserver = new window.PerformanceObserver(function () {
                clearTimeout(perfTimer);
                perfTimer = window.setTimeout(function () {
                    _this.perfObserverStop();
                }, _this.mutaStopTime);
            });
            this.perfObserver.observe({ entryTypes: ['resource'] });
        }
        else {
            perfDone = true;
            this.handleFspReport();
        }
    };
    /**
     * mutationObserver 回调，用与将该次收集到的 dom 变更推入 变更记录数组 用与fsp 计算
     * @param mutations mutationObserver 回调触发的 mutations 数组
     * @param startTime 该次变更的发生时间据统计起点的耗时
     * @param reset 当发生新的 mutation 时，是否重新新建 dom 变更定时器
     */
    PluginFsp.prototype.mutaCallback = function (mutations, startTime, reset) {
        var _this = this;
        if (reset)
            this.resetTimer(reset);
        startTime = startTime || Date.now();
        window.setTimeout(function () {
            if (domDone)
                return;
            logger_1.default.log('DOM原始变更', startTime, mutations);
            // 筛选有效的MutationRecord
            mutations
                .filter(function (mutation) {
                var targetNodeName = (mutation.target.nodeName || '').toUpperCase();
                return (mutation.type === 'childList' &&
                    targetNodeName &&
                    NodesFilter.indexOf(targetNodeName) === -1 &&
                    mutation.addedNodes &&
                    mutation.addedNodes.length);
            })
                .forEach(function (mutation) {
                // 筛选有效的新增节点
                var addedNodes = Array.prototype.slice
                    .call(mutation.addedNodes, 0)
                    .filter(function (node) {
                    var nodeName = ((node === null || node === void 0 ? void 0 : node.nodeName) || '').toUpperCase();
                    return ((node === null || node === void 0 ? void 0 : node.nodeType) === 1 && // 忽略非元素节点
                        nodeName &&
                        NodesFilter.indexOf(nodeName) === -1 && // 忽略非视觉元素
                        node.isConnected !== false && // 忽略未挂载至DOM树的元素
                        !(_this.ignoreIframe && nodeName === 'IFRAME') && // 忽略iframe
                        !shouldIgnoreNode(node, _this.ignoreArr)); // 忽略业务手动配置的元素
                });
                if (!(addedNodes && addedNodes.length && addedNodes[0]))
                    return;
                var firstNode = addedNodes[0];
                var rect = firstNode.getBoundingClientRect && firstNode.getBoundingClientRect();
                if (rect &&
                    rect.width &&
                    rect.height &&
                    rect.top > 0 &&
                    rect.top <= windowHeight &&
                    rect.left >= 0 &&
                    rect.left <= windowWidth) {
                    // 记录筛选后的新增节点及其对应时间, 用于之后FSP的计算
                    mutaRecords.push({
                        parent: mutation.target,
                        nodes: addedNodes,
                        startTime: startTime,
                    });
                }
                // 支持自定义响应用户交互后停止DOM变化监听
                if (document && util_1.isFunction(document.querySelectorAll)) {
                    addedNodes.forEach(function (node) {
                        _this.addEventToStopObserver(node);
                    });
                }
            });
        }, 0);
    };
    PluginFsp.prototype.resetTimer = function (newTimer) {
        var _this = this;
        if (domTimer)
            clearTimeout(domTimer);
        if (newTimer) {
            domTimer = window.setTimeout(function () {
                logger_1.default.log(_this.mutaStopTime + "ms\u65F6\u95F4\u5185\u6CA1\u6709\u76D1\u542C\u5230\u65B0\u7684DOM\u53D8\u5316, \u505C\u6B62DOM\u53D8\u5316\u76D1\u542C");
                _this.mutaObserverStop();
            }, this.mutaStopTime);
        }
    };
    PluginFsp.prototype.handleFspReport = function () {
        try {
            if (!domDone || !perfDone) {
                return false;
            }
            var fsp = this.domFsp || 0;
            logger_1.default.log('dom 首屏时间: ', fsp);
            if (this.config.includeImage) {
                var imageFsp = caculateImageTiming(this.ignoreArr, imgPattern);
                collectOrigin = imageFsp > fsp ? 'img' : 'dom';
                logger_1.default.log('image 首屏时间: ', imageFsp);
                fsp = Math.max(imageFsp, fsp);
            }
            logger_1.default.log('最终首屏时间: ', fsp, '首屏内变更: ', mutationCount);
            if (fsp) {
                // 格式化自定义tags
                var customTags = this.formatCustomTags();
                this.addData({
                    type: const_1.METRICS_FSP,
                    ts: Date.now(),
                    value: fsp,
                    tags: tslib_1.__assign(tslib_1.__assign({}, customTags), { triggerType: triggerType,
                        mutationCount: mutationCount,
                        hasContainerLoad: hasContainerLoad,
                        collectOrigin: collectOrigin }),
                });
            }
        }
        catch (error) {
            logger_1.default.log('获取 fsp 失败', error);
        }
    };
    PluginFsp.prototype.mutaObserverStop = function () {
        if (this.observer && this.observer.disconnect) {
            try {
                this.observer.disconnect();
                this.observer = null;
                if (domDone)
                    return;
                this.domFsp = this.calcuFSP();
                this.handleFspReport();
                this.resetTimer(false);
            }
            catch (error) {
                logger_1.default.log('observer disconnect err', error);
            }
        }
    };
    /**
     * 监听到交互事件 将 dom 和 performance 监听同时停止
     * @param type 事件类型
     */
    PluginFsp.prototype.handleInteract = function () {
        triggerType = TRIGGER_INTERACT;
        this.mutaObserverStop();
        this.perfObserverStop();
    };
    PluginFsp.prototype.interactToStopObserver = function () {
        var _this = this;
        if (domDone)
            return;
        var callback = function (e) {
            // 当监听到交互事件 发生在页面根节点、或前端框架dom容器节点时，认为还未加载完毕 需过滤掉该次交互
            var target = e.target;
            if (target === document.documentElement ||
                target === document.body ||
                (target && target.id === 'app')) {
                return;
            }
            if (domDone && perfDone) {
                removeListener();
                return;
            }
            logger_1.default.log('onload后响应到用户交互事件, 停止DOM变化监听 停止 performanceObserver 资源加载监听');
            _this.handleInteract();
            removeListener();
        };
        var removeListener = function () {
            document.removeEventListener('click', callback);
            document.removeEventListener('wheel', callback);
            document.removeEventListener('touchmove', callback);
        };
        document.addEventListener('click', callback);
        document.addEventListener('wheel', callback);
        document.addEventListener('touchmove', callback);
    };
    PluginFsp.prototype.perfObserverStop = function () {
        try {
            if (this.perfObserver && this.perfObserver.disconnect) {
                this.perfObserver.disconnect();
                this.perfObserver = null;
            }
            if (perfDone)
                return;
            perfDone = true;
            this.handleFspReport();
        }
        catch (error) {
            logger_1.default.log('perfObserver disconnect err', error);
        }
    };
    // 支持业务自定义响应用户交互以停止DOM变化监听
    PluginFsp.prototype.addEventToStopObserver = function (node) {
        var _this = this;
        Array.prototype.slice
            .call(node.querySelectorAll('[interactive]'), 0)
            .forEach(function (eventNode) {
            var type = (eventNode.getAttribute && eventNode.getAttribute('interactive')) || 'click';
            var callback = function () {
                _this.handleInteract();
                eventNode.removeEventListener(type, callback);
            };
            eventNode.addEventListener(type, callback);
        });
    };
    /**
     * 根据 mutation 变更记录，计算依据 dom 变更计算的 fsp 值
     * @returns dom 变更 fsp 值
     */
    PluginFsp.prototype.calcuFSP = function () {
        try {
            var time = Date.now();
            // 将变更记录时间差在 1ms 内的记录合并
            var combindRecords_1 = mutaRecords.reduce(function (combined, cur) {
                if (combined.length > 0) {
                    var lastRecord = combined[combined.length - 1];
                    if (cur.startTime - lastRecord.startTime <= 1) {
                        lastRecord.records.push(cur);
                    }
                    else {
                        combined.push({
                            startTime: cur.startTime,
                            records: [cur],
                        });
                    }
                }
                else {
                    combined.push({
                        startTime: cur.startTime,
                        records: [cur],
                    });
                }
                return combined;
            }, []);
            //在记录的变更数组中，从后向前依次取出变更， 找到符合条件：新增节点面积总和 大于可视窗口面积 5% 的变更 停止递归，
            //对应的记录的 startTime 为 dom fsp 时间
            var singleNodeCal_1 = function () {
                // 如果变更记录数组为空，或者极限情况每次变更面积都小于面积阀值，取消上报
                if (combindRecords_1.length === 0)
                    return null;
                var _a = combindRecords_1.pop(), startTime = _a.startTime, records = _a.records;
                // 计算合并后记录中 新增节点在首屏内可见元素面积和
                var totalArea = records.reduce(function (area, record) {
                    var parent = record.parent, nodes = record.nodes;
                    var parentStyle = window.getComputedStyle(parent);
                    // 计算面积的新增节点需要满足条件：
                    // 条件1 如果父元素为 display：none 直接跳过 继续递归 子元素不可能为可见
                    if (parentStyle.display === 'none') {
                        return area;
                    }
                    // 条件2：如果该次变更为 slider 变更 不计入计算
                    if (isSliderMutation(record)) {
                        return area;
                    }
                    var parentRect = getRect(parent, parentStyle);
                    var intersectArea = 0; // 子节点面积总和 不考虑与父节点相交
                    var totalOutArea = 0; // 子节点面积和 考虑与父节点相交
                    nodes.forEach(function (node) {
                        var nodeRect = getRect(node);
                        // 条件3： 子节点必须在首屏内并且可见
                        if (nodeRect) {
                            var nodeArea = nodeRect.width * nodeRect.height;
                            if (parentRect) {
                                if (isIntersect(parentRect, nodeRect)) {
                                    intersectArea += nodeArea;
                                }
                                else {
                                    totalOutArea += nodeArea;
                                }
                            }
                            else {
                                totalOutArea += nodeArea;
                            }
                        }
                    });
                    return area + intersectArea + totalOutArea;
                }, 0);
                if (totalArea > MinArea) {
                    logger_1.default.log('final records are: ', records, startTime);
                    return { totalArea: totalArea, startTime: startTime };
                }
                else {
                    return singleNodeCal_1();
                }
            };
            var _a = singleNodeCal_1() || {}, totalArea = _a.totalArea, startTime = _a.startTime;
            logger_1.default.log("area \u8BA1\u7B97 FSP\uFF1A" + startTime + ", \u8017\u65F6: " + (Date.now() - time) + ", \u9762\u79EF: " + totalArea);
            // 根据fspStartTime 计算真实的 fsp 耗时
            var fspDuration = startTime ? startTime - fspStartTime : 0;
            domDone = true;
            mutationCount = mutaRecords.length;
            mutaRecords = [];
            return fspDuration;
        }
        catch (e) {
            domDone = true;
            mutaRecords = [];
            logger_1.default.warn(e);
        }
        return 0;
    };
    /** 统一处理自定义秒开tag */
    PluginFsp.prototype.formatCustomTags = function () {
        var tags = this.config.customTags;
        var formatedTags = {};
        if (util_1.isObject(tags)) {
            var keys = Object.keys(tags);
            keys.forEach(function (key) {
                var tagValue = tags[key];
                // 限制每个维度值长度不能超过 128字符 避免造成服务端压力过大
                if (String(tagValue).length < MAX_TAG_VALUE_LENGTH) {
                    var prefixedKey = "3rd_" + key;
                    formatedTags[prefixedKey] = tagValue;
                }
            });
        }
        return formatedTags;
    };
    PluginFsp.id = typings_1.PLUGIN_NAME.FSP;
    return PluginFsp;
}(basePlugin_1.default));
exports.PluginFsp = PluginFsp;
// 使用HTML标签属性自定义忽略一些元素
function shouldIgnoreNode(node, ignoreDom) {
    if (node.__fspIgnored) {
        return true;
    }
    if (ignoreDom) {
        node.__fspIgnored = node.hasAttribute && node.hasAttribute(ignoreDom);
    }
    if (!node.__fspIgnored && node.parentNode && node.parentNode !== document.body) {
        node.__fspIgnored = shouldIgnoreNode(node.parentNode, ignoreDom);
    }
    return node.__fspIgnored;
}
// 视口viewport尺寸计算:
// 可用方案: window.innerHeight; 页面根节点元素尺寸; 创建占位元素并设置CSS视口定位的元素尺寸
// 不适用方案: window.outerHeight会忽略页面缩放比例且包含工具栏菜单栏高度; screen.height对非全屏场景不适用
function getViewportSize() {
    var view = {
        height: window.innerHeight || 0,
        width: window.innerWidth || 0,
    };
    return view;
}
/**
 * 获取首屏内图片渲染计算的首屏时间
 * @param ignoreTag 忽略 dom 节点标识 默认 perf-ignore
 * @param imgPattern 图片匹配正则
 * @returns
 */
function caculateImageTiming(ignoreTag, imgPattern) {
    var inScreenImgTimes = img_1.getImageTimingsInFirstScreen(ignoreTag, imgPattern, scrollDom);
    if (inScreenImgTimes.length) {
        var imageFSP = Math.round(inScreenImgTimes[0]);
        return imageFSP;
    }
    return 0;
}
/**
 * 获取节点在页面状态： 不可见或不在首屏 返回 false， 首屏内可见返回 DOMRect 对象
 * @param node 查询节点
 * @returns 节点状态
 */
function getRect(node, style) {
    if (!node) {
        return false;
    }
    style = style || window.getComputedStyle(node);
    var _a = style || {}, visibility = _a.visibility, display = _a.display;
    if (visibility === 'hidden' || display === 'none')
        return false;
    var rect = (node.getBoundingClientRect && node.getBoundingClientRect()) || {};
    var top = rect.top, left = rect.left;
    // 当页面发生滚动，需要在 left 和 top 基础上加上 window scrollLeft scrollTop 计算不发生滚动时，元素是否在首屏内
    var scrollTop = window.scrollY || window.pageYOffset;
    var scrollLeft = window.scrollX || window.pageXOffset;
    if (scrollTop + top < windowHeight && scrollLeft + left < windowWidth) {
        return rect;
    }
    return false;
}
/**
 * 判断该次dom变更是否为 slider 变更
 * @param record dom变更记录
 */
function isSliderMutation(record) {
    var nodes = record.nodes, parent = record.parent, startTime = record.startTime;
    // 排除 slider 变更 特征：单次变更只有一个新增元素，变更周期固定 形成周期至少需要3次变更
    if (nodes.length > 1)
        return false;
    var possibleSliderRecords = mutaRecords.filter(function (it) { return it.parent === parent; });
    if (possibleSliderRecords.length <= 2)
        return false;
    // 排除初始加载的列表项
    var initStartTIme = possibleSliderRecords[0].startTime;
    // 如果当前判断的 record startTime 和初始加载的 startTime 相同 则不算为轮播
    if (startTime === initStartTIme) {
        return false;
    }
    var notInitMutaIndex = parent.__notInitMutaIndex ||
        possibleSliderRecords.findIndex(function (item) { return item.startTime !== initStartTIme; });
    if (parent.__notInitMutaIndex === undefined) {
        parent.__notInitMutaIndex = notInitMutaIndex;
    }
    if (notInitMutaIndex === -1) {
        return false;
    }
    // 从非初始加载节点前一个节点开始进行轮播时间判断
    var excludeInitRecords = possibleSliderRecords.slice(notInitMutaIndex - 1);
    var deviation = excludeInitRecords[1].startTime - excludeInitRecords[0].startTime;
    for (var i = 2; i < excludeInitRecords.length; i++) {
        var newDeviation = excludeInitRecords[i].startTime - excludeInitRecords[i - 1].startTime;
        // 因为从setTimeout 触发dom 变更到 mutationObserver 监听到事件 时间可能不会完全和定时器的时间间隔一致 故留出 5ms buffer
        if (Math.abs(newDeviation - deviation) > 5) {
            return false;
        }
    }
    return true;
}
/**
 * 根据2个节点的 domRect 对象 判断两个节点在页面中是否相交
 * @param rect1 节点1 DOMRect
 * @param rect2 节点2 DOMRect
 */
function isIntersect(rect1, rect2) {
    var x1 = rect1.x, y1 = rect1.y, width1 = rect1.width, height1 = rect1.height;
    var x2 = rect2.x, y2 = rect2.y, width2 = rect2.width, height2 = rect2.height;
    return (((x2 > x1 && x1 + width1 >= x2) || (x2 <= x1 && x2 + width2 >= x1)) &&
        ((y2 > y1 && y1 + height1 >= y2) || (y2 <= y1 && y2 + height2 >= y1)));
}
//# sourceMappingURL=fsp.js.map